import { useState, useEffect } from 'react';
import { api } from '../api';
import { styles } from '../styles';
import { BackIcon, Spinner } from '../components/Icons';

import ReactMarkdown from 'react-markdown';

export default function NotificationsScreen({ onBack }) {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadNotifications();
  }, []);

  const loadNotifications = async () => {
    try {
      const data = await api.get('/notifications?limit=50');
      setNotifications(data.notifications);
    } catch (e) {
      console.error('Failed to load notifications', e);
    } finally {
      setLoading(false);
    }
  };

  const markRead = async (id) => {
    await api.post(`/notifications/${id}/read`);
    setNotifications(prev => 
      prev.map(n => n.id === id ? { ...n, read_at: new Date().toISOString() } : n)
    );
  };

  const markAllRead = async () => {
    await api.post('/notifications/read-all');
    setNotifications(prev => 
      prev.map(n => ({ ...n, read_at: n.read_at || new Date().toISOString() }))
    );
  };

  const unreadCount = notifications.filter(n => !n.read_at).length;

  if (loading) {
    return (
      <div style={{...styles.screen, ...styles.centered}}>
        <Spinner />
      </div>
    );
  }

  return (
    <div style={styles.screen}>
      <header style={styles.header}>
        <button style={styles.backBtn} onClick={onBack}>
          <BackIcon />
        </button>
        <h1 style={styles.headerTitle}>Notifications</h1>
        {unreadCount > 0 && (
          <button style={notifStyles.markAllBtn} onClick={markAllRead}>
            Mark all read
          </button>
        )}
        {unreadCount === 0 && <div style={{ width: 80 }} />}
      </header>

      {notifications.length === 0 ? (
        <p style={notifStyles.empty}>No notifications yet</p>
      ) : (
        <div style={notifStyles.list}>
          {notifications.map(n => (
            <button
              key={n.id}
              style={{
                ...notifStyles.item,
                backgroundColor: n.read_at ? '#f8fafc' : 'white',
              }}
              onClick={() => !n.read_at && markRead(n.id)}
            >
              <div style={notifStyles.itemContent}>
                {!n.read_at && <div style={notifStyles.unreadDot} />}
                <div style={notifStyles.itemText}>
                <div style={notifStyles.message}>
                  <ReactMarkdown
                    components={{
                      p: ({ children }) => <p style={{ margin: '0 0 8px 0' }}>{children}</p>,
                      strong: ({ children }) => <strong style={{ fontWeight: 600 }}>{children}</strong>,
                    }}
                  >
                    {n.message}
                  </ReactMarkdown>
                </div>
                  <span style={notifStyles.time}>
                    {new Date(n.created_at).toLocaleDateString('en-US', {
                      month: 'short',
                      day: 'numeric',
                      hour: 'numeric',
                      minute: '2-digit',
                    })}
                  </span>
                </div>
              </div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

const notifStyles = {
  markAllBtn: {
    fontSize: 13,
    color: '#6366f1',
    backgroundColor: 'transparent',
    border: 'none',
    cursor: 'pointer',
    padding: '8px 0',
  },
  empty: {
    textAlign: 'center',
    color: '#94a3b8',
    padding: 40,
  },
  list: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  item: {
    width: '100%',
    padding: 14,
    borderRadius: 12,
    border: '1px solid #e2e8f0',
    cursor: 'pointer',
    textAlign: 'left',
  },
  itemContent: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 10,
  },
  unreadDot: {
    width: 8,
    height: 8,
    borderRadius: '50%',
    backgroundColor: '#6366f1',
    marginTop: 6,
    flexShrink: 0,
  },
  itemText: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  message: {
    fontSize: 14,
    color: '#1e293b',
    lineHeight: 1.4,
  },
  time: {
    fontSize: 12,
    color: '#94a3b8',
  },
};